class ModalDialogContactProduct extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
    this.init();
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

init() {
  const form = document.getElementById('ContactFormOutOfStock');
  if (form) {
    form.modalInstance = this;
    form.addEventListener('submit', async function handleSubmit(event){
      event.preventDefault();
      const localeInput = document.querySelector('input[name="contact[locale]"]');
      const localeValue = localeInput ? localeInput.value : null;
      const locationIsoInput = document.querySelector('input[name="contact[location-iso]"]');
      const locationIsoValue = locationIsoInput ? locationIsoInput.value : null;
      const completeLocale = localeValue+"-"+locationIsoValue
      const locationInput = document.querySelector('input[name="contact[location]"]');
      const locationValue = locationInput ? locationInput.value : null;
      const button = this.querySelector('button');
      button.disabled = true;
      const modal = this.modalInstance;
      let errorContainer = document.getElementById("ContactForm-email-error");
      const submitBlock = document.querySelector(".contact__submit");
      const userEmail = this.querySelector('input[name="contact[email]"]').value;

      console.log("Locale:", localeValue);

      if (!modal || !userEmail){
        errorContainer.style.display = 'block';
        submitBlock.style.marginTop = '20px';
        document.querySelector(".contact__button button").removeAttribute("disabled");
        return;
      } else {
         errorContainer.style.display = 'none';
      }

      const backInStockOptions = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: '2025-01-15',
          'content-type': 'application/vnd.api+json'
        },
        body: `{"data":{"type":"back-in-stock-subscription","attributes":{"profile":{"data":{"type":"profile","attributes":{"email":"${userEmail}"}}},"channels":["EMAIL"]},"relationships":{"variant":{"data":{"type":"catalog-variant","id":"$shopify:::$default:::${modal.variant}"}}}}}`
      };

      let backInStockSuccess = false;
      try {
        const res = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=ViSTET', backInStockOptions);
        if (res.status === 202) {
          backInStockSuccess = true;
        } else {
          // Handle potential errors from the back-in-stock request
          console.error('Back in stock subscription failed with status:', res.status);
          const errorData = await res.json();
          console.error('Back in stock error details:', errorData);
        }
      } catch (err) {
        console.error('Error during back in stock subscription:', err);
      }      
      if (backInStockSuccess) {
        document.querySelector(".form-status-success").style.display = "block";
        document.querySelector(".product-popup-modal__form").style.display = "none";
      } else {
        
        document.querySelector(".form-status-error").style.display = "block";
        document.querySelector(".product-popup-modal__form").style.display = "none";
      }
      button.disabled = false;

    });

    form.onsubmit = null;
  }
}

  show(id_account, variant, product) {
    if (id_account) {
      this.id_account = id_account;
    }
    if (variant) {
      this.variant = variant;
    }
    if (product) {
      this.product = product;
    }
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    document.querySelector('.form-status-success').style.display = 'none';
    document.querySelector('.product-popup-modal__form').style.display = 'block';
    document.querySelector('.form-status-error').style.display = 'none';
    document.querySelector('.contact__button button').removeAttribute('disabled');
    this.removeAttribute('open');
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog-contact-product', ModalDialogContactProduct);

class ModalOpenerStock extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      if (button && button.getAttribute('aria-disabled') === 'true') {
        const modalContact = document.getElementById(`PopupModalContact-agotado`);
        const id_account = this.dataset.idAccount;
        const variant = this.dataset.variant;
        const product = this.dataset.product;
        if (modalContact) {
          modalContact.show(id_account, variant, product);
        }
        return;
      }
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-openers-stock', ModalOpenerStock);

function moveForDesktop() {
  const statusEl = document.querySelector('.pdp-infor-status-content');
  const targetEl = document.querySelector('.quantity-edit-section');

  if (statusEl && targetEl) {
    targetEl.style.flex = '0 0 100%';
    statusEl.style.flexBasis = '50%';
    statusEl.style.paddingLeft = '10px';
    targetEl.appendChild(statusEl);
  }
}

function moveForMobile() {
  const addBtn = document.querySelector('.product-info__block .product-info__add-button button[type="submit"]');
  const targetEl = document.querySelector('.quantity-edit-section');
  const dynamicButton = document.querySelector('.product-info__add-button .shopify-payment-button');

  if (addBtn && targetEl) {
    addBtn.style.color = '#000';
    addBtn.style.borderColor = '#000';
    addBtn.style.backgroundColor = '#ffffffe6';
    addBtn.style.backgroundImage = 'linear-gradient(104deg, #00000012 60%, #fff 60% 100%)';
    addBtn.style.padding = '13px 26px !important';
    addBtn.style.height = '42px';
    targetEl.appendChild(addBtn);
    targetEl.style.height = '42px'
    dynamicButton.style.flexBasis = '100%';
  }
}

function handleResponsiveMove() {
  if (window.matchMedia("(min-width: 1024px)").matches) {
    moveForDesktop();
  } else {
    moveForMobile();
  }
}

document.addEventListener("DOMContentLoaded", handleResponsiveMove);
window.addEventListener("resize", handleResponsiveMove);
